<template>
  <div class="dataGrid" :style="{ ...containerStyle, ...getOverStyle, ...getContentStyle }">
    <template v-if="!options.emptyData">
        <dataGridCell
          v-for="cell in options.cells"
          :key="cell.cellId"
          :parentOptions="options"
          :options="cell.options"
          :elementOptions="cell.elementOptions"
          :myid="{ ...myid, cellId: cell.cellId }"
          :zoom="zoom"
        >
      </dataGridCell>
    </template>
    <!-- 空数据 -->
    <div class="null-data" v-else>
      <img src="../../../assets/images/img-null-data-light.png" alt="" />
      <p v-if="options.errorCode" class="textColor">{{ options.errorCode }}报错</p>
      <p v-else>暂无数据</p>
    </div>
  </div>
</template>

<script>
import { replaceUrlParam } from "utils/index"
import animateMixin from "utils/event/animateMixin.js"
import subPageEventMixin from "utils/event/subPageEventMixin.js"
import { UpdateGridData } from "../UpdateGridData.js"
import dataGridCell from "./cell.vue"
export default {
  mixins: [animateMixin, subPageEventMixin],
  name: "dataGrid",
  components: {
    dataGridCell
  },
  props: {
    options: {
      type: Object,
      default: null
    },
    myid: {
      type: Object,
      default: null
    },
    zoom: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      isDragover: false,
      activeIndex: -1, // 激活组件
      resizeOb: null,
      currentHalf: false //当前位置是否超过当前元素的一半
    }
  },
  mounted() {
    // 监听当前自动布局尺寸的改变
  },
  beforeDestroy() {},
  watch: {},
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    showRightToolbar() {
      return this.$store.state.states.showRightToolbar
    },
    themeColor() {
      return this.$store.state[this.request_prefix].page.themeColor
    },
    boxShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.boxShadowH)) {
        this.options.boxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          // tmpStyle += `${_this.options.boxShadowH[index]}px ${_this.options.boxShadowV[index]}px ${_this.options.boxShadowBlur[index]}px ${_this.options.boxShadowSpread[index]}px ${_this.options.boxShadowColor[index]}`
          tmpStyle += `${_this.options.boxShadowH[index]}px ${_this.options.boxShadowV[index]}px ${_this.options.boxShadowBlur[index]}px ${_this.options.boxShadowSpread[index]}px ${_this.$parseColor(_this.options.boxShadowColor[index])}`
        })
      } else {
        // tmpStyle += `${this.options.boxShadowH}px ${this.options.boxShadowV}px ${this.options.boxShadowBlur}px ${this.options.boxShadowSpread}px ${this.options.boxShadowColor}`
        tmpStyle += `${this.options.boxShadowH}px ${this.options.boxShadowV}px ${this.options.boxShadowBlur}px ${this.options.boxShadowSpread}px ${this.$parseColor(this.options.boxShadowColor)}`
      }
      return tmpStyle
    },
    getPaddingStyle() {
      let padding = `${this.options.padding}px`
      if (this.options.paddingTypeFlag === 2) {
        padding = ` ${this.options.paddingTop}px  ${this.options.paddingRight}px  ${this.options.paddingBottom}px  ${this.options.paddingLeft}px`
      }
      return padding
    },
    bgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.background
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hasOwnProperty("bgColorIsThemeColor") ? this.options.bgColorIsThemeColor : false,
            color: this.options.bgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize = containerBg.backgroundSize
              ? `${containerBg.backgroundSize},${bg.clipSize}`
              : `${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition
              ? `${containerBg.backgroundPosition},${bg.alignType}`
              : `${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat
              ? `${containerBg.backgroundRepeat},${bg.repeatType}`
              : `${bg.repeatType}`
            break
          case "color":
            containerBg.backgroundColor = this.$parseColor(bg)
            // containerBg.backgroundColor = bg.isThemeColor ? this.themeColor : bg.color
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    containerStyle() {
      if (this.options) {
        let borderW = ""
        if (Array.isArray(this.options.borderWidth)) {
          this.options.borderWidth.forEach(item => [(borderW += ` ${item}px`)])
        } else {
          borderW += ` ${this.options.borderWidth}px`
        }
        let maxWidth = ""
        let minWidth = ""
        let maxHeight = ""
        let minHeight = ""
        let options = this.options
        maxWidth = options.showMaxWidth ? options.maxWidth + "px" : ""
        minWidth = options.showMinWidth ? options.minWidth + "px" : ""
        maxHeight = options.showMaxHeight ? options.maxHeight + "px" : ""
        minHeight = options.showMinHeight ? options.minHeight + "px" : ""
        return {
          ...this.bgStyle,
          height: "100%",
          opacity: this.options.opacity / 100,
          "border-style": this.options.borderStyle,
          // "border-color": this.options.borderIsThemeColor
          //   ? this.themeColor
          //   : this.options.borderColor?.color
          //   ? this.options.borderColor?.color
          //   : this.options.borderColor,
          "border-color": this.$parseColor(this.options.borderColor, {
            isThemeColor: this.options.borderIsThemeColor
          }),
          "border-width": this.options.showBorder !== false ? borderW : 0,
          "box-shadow": this.boxShadowStyle,
          "border-top-left-radius": this.options.borderTopLeftRadius + "px",
          "border-top-right-radius": this.options.borderTopRightRadius + "px",
          "border-bottom-left-radius": this.options.borderBottomLeftRadius + "px",
          "border-bottom-right-radius": this.options.borderBottomRightRadius + "px",
          padding: this.getPaddingStyle,
          "max-width": maxWidth,
          "min-width": minWidth,
          "max-height": maxHeight,
          "min-height": minHeight,
          outline: this.options?.elementOptions?.length > 0 ? "none" : "1px dashed var(--thirdTextColor)"
        }
      }
    },
    getContentStyle() {
      let style = {}
      const rootCellOptions = this.options.cells[0].options
      // 如果划分的列数不能被整除，需要计算单元格的宽度，保留小数点后两位
      let cellWidth = rootCellOptions.width
      if (rootCellOptions.widthType === "%") {
        cellWidth = (100 / this.options.col).toFixed(2)
      }
      style = {
        display: "grid",
        "border-top-left-radius": this.options.borderTopLeftRadius + "px",
        "border-top-right-radius": this.options.borderTopRightRadius + "px",
        "border-bottom-left-radius": this.options.borderBottomLeftRadius + "px",
        "border-bottom-right-radius": this.options.borderBottomRightRadius + "px",
        "grid-template-columns": `repeat(${this.options.col}, calc(${cellWidth}${rootCellOptions.widthType} - ${(this.options.columnGap * (this.options.col - 1)) / this.options.col}px))`,
        "grid-template-rows": `repeat(${this.options.row}, calc(${rootCellOptions.height}${
          rootCellOptions.heightType
        } - ${(this.options.rowGap * (this.options.row - 1)) / this.options.row}px))`,
        "grid-row-gap": this.options.rowGap + "px",
        "grid-column-gap": this.options.columnGap + "px"
      }
      if (rootCellOptions.height === "auto") {
        style["grid-template-rows"] = `repeat(${this.options.row}, auto)`
      }
      return style
    },
    // 溢出判断显示隐藏滚动
    getOverStyle() {
      let style = {}
      if (this.options.emptyData) {
        return style
      }
      let overflow = "visible"
      if (this.options.overFlowType == "scroll") {
        overflow = "scroll"
      } else if (this.options.overFlowType) {
        overflow = this.options.overFlowType
      }
      style = {
        "overflow-y": overflow ? overflow : "hidden",
        "overflow-x": overflow === "visible" ? "unset" : "hidden"
      }
      // return {
      //   overflow:"visible" // 编辑页都展示出来，要不然工具栏出不来
      // }
      return style
    }
  },
  methods: {
    async timerUpdate(plugin) {
      const pageSize = this.options.row * this.options.col
      let restDataUrl = plugin.restDataUrl
      restDataUrl = replaceUrlParam(restDataUrl, "p2", pageSize)
      // 替换url中的参数
      Object.keys(plugin.params).forEach(key => {
        if (typeof plugin.params[key] !== "undefined") {
          restDataUrl = replaceUrlParam(restDataUrl, key, plugin.params[key])
        }
      })
      const updateGridData = new UpdateGridData(this)
      const { completeData, totalRecords, selectedDates, selectedDateMap } = await updateGridData.upDateData({
        rectAttr: this.options,
        restDataUrl: restDataUrl,
        ids: {
          ...this.myid
        },
        addCb: param => {},
        hideComponentCb: (param, opacity, display) => {},
        showComponentCb: (param, opacity, display) => {},
        updateCb: completeparam => {
          let completeParamClone = Object.assign({ ...this.myid }, completeparam)
          this.$store.dispatch(this.request_prefix + "/changeDataGridOptions", completeParamClone)
        },
        componentBoxUpdateCb: ({ cellId, dataUrl, dataId, pageType }) => {
          let param = {
            ...this.myid,
            cellId: cellId,
            option_name: "opacity",
            option_val: 100
          }
          this.$store.dispatch(this.request_prefix + "/changeDataGridOptions", param)

          let param1 = {
            ...this.myid,
            cellId: cellId,
            option_name: "dataUrl",
            option_val: dataUrl
          }
          this.$store.dispatch(this.request_prefix + "/changeDataGridOptions", param1)
          let param2 = {
            ...this.myid,
            cellId: cellId,
            option_name: "dataId",
            option_val: dataId
          }
          this.$store.dispatch(this.request_prefix + "/changeDataGridOptions", param2)
          let param3 = {
            ...this.myid,
            cellId: cellId,
            option_name: "pageType",
            option_val: pageType
          }
          this.$store.dispatch(this.request_prefix + "/changeDataGridOptions", param3)
        },
        componentBoxUpdateOpacity: ({ cellId, isShow, dataLength }) => {
          let param = {
            ...this.myid,
            cellId: cellId,
            option_name: "isShow",
            option_val: isShow
          }
          this.$store.dispatch(this.request_prefix + "/changeDataGridOptions", param)
        },
        delElementCb: (ids, opacity) => {},
        updateEleCb: (val, content_name, deep, deepName, ids) => {
          this.$changeOptionsEV(val, content_name, deep, deepName, ids, true)
        }
      })
      if (typeof plugin.initCxPaginationData === "function") plugin.initCxPaginationData(totalRecords, pageSize)
      if (typeof plugin.initCxCalendarData === "function" && (selectedDates.length > 0 || selectedDateMap.length > 0)) plugin.initCxCalendarData(selectedDates, selectedDateMap)
      updateGridData.startUpdateGrid(completeData)
    },
    initSubPageDataGridData(plugin) {
      this.$changeOptionsEV(plugin.showDataGrid, "isShow", false, null, this.myid, true)
      if (plugin.showDataGrid) {
        this.timerUpdate(plugin)
      }
    }
  }
}
</script>

<style scoped>
.auto-layout-component,
.auto-layout-content {
  position: relative;
  width: 100%;
  height: 100%;
  max-width: var(--maxWidth);
  min-width: var(--minWidth);
  max-height: var(--maxHeight);
  min-height: var(--minHeight);
}

.emptyColText {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: var(--thirdTextColor);
  font-size: 14px;
}

::v-deep .row-col-layout > .vdr {
  flex-shrink: 0; /* flex布局不改变子元素宽高 */
  position: relative;
  transform: none !important;
}
.isDrag-over .row-col-layout,
.row-col-layout .dragging {
  cursor: grab !important;
}
.isDrag-over .row-col-layout ::v-deep .dragging > div {
  opacity: 0.5 !important;
}
.row-col-layout.vertical > .vdr:last-child {
  margin-bottom: 0 !important;
}
.row-col-layout.horizon > .vdr:last-child {
  margin-right: 0 !important;
}

.vertical > .ghost::after {
  content: "";
  position: absolute;
  left: 0;
  width: 100%;
  height: 3px;
  background: var(--themeColor);
}
.vertical > .ghost.before::after {
  top: var(--custom-margin);
}
.vertical > .ghost.after::after {
  bottom: var(--custom-margin);
}
.vdr.before:first-child::after {
  /* 第一个元素前不要偏移值 */
  top: 0 !important;
  left: 0 !important;
}
.horizon > .ghost::after {
  content: "";
  position: absolute;
  top: 0;
  width: 3px;
  height: 100%;
  background: var(--themeColor);
}
.horizon > .ghost.before::after {
  left: var(--custom-margin);
}
.horizon > .ghost.after::after {
  right: var(--custom-margin);
}
.vdr.after:last-child::after {
  /* 最后一个元素后不要偏移值 */
  bottom: 0 !important;
  right: 0 !important;
}
.vdr_shade {
  cursor: grab !important;
}
.vdr.active > .auto-layout-component,
.vdr.vdr_hover > .auto-layout-component {
  outline: none !important;
}
</style>
